import { useContext } from 'react';
import Tour from 'reactour';
import AuthContext from '../../store/auth-context';
import useGuidedTour from '../../hooks/use-guided-tour';
import {
	disableBodyScroll,
	enableBodyScroll
} from 'body-scroll-lock';
import { piOnboardingTourSteps } from '../../utils/piTours';
import { qamOnboardingTourSteps } from '../../utils/qamTours';

const lsOnboadingTourKey = 'onboarding-tour';

const OnboardingTour = () => {
	const authCtx = useContext(AuthContext);

	const { active } = useGuidedTour(
		lsOnboadingTourKey,
		'/dashboard'
	);

	let onboardingTourSteps = [];

	if (authCtx.userData.role === 'QA') {
		onboardingTourSteps = [...qamOnboardingTourSteps];
	} else {
		onboardingTourSteps = [...piOnboardingTourSteps];
	}

	const handleTourClose = () => {
		localStorage.setItem(lsOnboadingTourKey, true);
		window.location.reload();
	};

	const disableScroll = (target) => {
		disableBodyScroll(target);
	};

	const enableScroll = (target) => {
		enableBodyScroll(target);
	};

	if (!active) {
		return;
	}

	return (
		<Tour
			steps={onboardingTourSteps}
			isOpen={active}
			onRequestClose={handleTourClose}
			closeWithMask={false}
			accentColor='#242a60'
			rounded={7}
			disableInteraction={true}
			onAfterOpen={disableScroll}
			onBeforeClose={enableScroll}
		/>
	);
};

export default OnboardingTour;
